import { styled } from '@mui/material/styles';
import MuiSwitch from '@mui/material/Switch';
import { ChangeEvent, useEffect, useState } from 'react';
import { ValueCallback } from 'types/callbacks';
import styles from './About.module.css';

// TODO(arthur): Fix these material UI styling issues.
export const CustomSwitch = styled(MuiSwitch)(() => ({
  width: 48,
  height: 24,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#57A5E0',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 20,
    height: 20,
    marginTop: 2,
    marginLeft: 2,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: '#0b0b0b',
  },
  '& .MuiSwitch-switchBase .MuiSwitch-input': {
    left: '-100%',
    width: '300%',
  },
}));

type Props = {
  label?: string;
  initialValue?: boolean;
  onChange?: ValueCallback<boolean>;
};

const RiveSwitch = ({ label, initialValue = false, onChange }: Props) => {
  const [isChecked, setChecked] = useState<boolean>(initialValue);

  useEffect(() => setChecked(initialValue), [initialValue]);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setChecked(event.target.checked);
    onChange?.(event.target.checked);
  }

  return (
    <div className={styles.SwitchContainer}>
      <h3>{label}</h3>
      <CustomSwitch
        className={styles.Switch}
        checked={isChecked}
        onChange={handleChange}
        name="checked"
      />
    </div>
  );
};

export default RiveSwitch;
